import React from "react";
import { Container, Box, makeStyles, Grid } from "@material-ui/core";
import Logo from "../assets/images/logo.PNG";
import { useHistory } from "react-router-dom";
import SlideDownModal from "../components/reusableComponents/SlideDownModal";
import Footer from "./Desktop/Footer";
import SearchEngine from "../form/SearchEngine";
import HeaderSection from "../components/reusableComponents/HeaderSection";
const useStyles = makeStyles(() => ({
  item: {
    //   backgroundColor: "#ee8622",
    display: "flex",
    listStyle: "none",
    marginBottom: 0,
    marginTop: 0,
    "&:hover": {
      backgroundColor: "#ee8622",
    },
  },
  li: {
    color: "white",
    padding: "4px 8px",
    background: "no-repeat",
    borderRight: "none",
  },
  card: {
    // padding: 10,
    "&:hover": {
      // backgroundColor: "#ee8622",
      boxShadow: "rgb(149 157 165 / 20%) 0px 8px 24px",
    },
  },
}));
const SearchResult = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [header, SetHeader] = React.useState("onlineRecharge");

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handelHeader = (val) => {
    SetHeader(val);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <HeaderSection/>
      <Box style={{ background: "rgb(15, 63, 90)", padding: 50 }}></Box>
      <Container style={{ paddingLeft: 50, paddingRight: 50, paddingTop: 20 }}>
        <Box style={{ background: "#666", textAlign: "center", padding: 20 }}>
          <span
            style={{
              color: "white",
              fontFamily: "Open Sans,sans-serif",
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            Bagdogra - Bangalore
          </span>
          <p style={{ color: "white", fontSize: 12 }}> Tue 22nd, Nov 2022 </p>
        </Box>
      </Container>
      <Container style={{ paddingLeft: 50, paddingRight: 50 }}>
        {Array.from(Array(10)).map((i) => {
          return (
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 15,
                border: "1px solid #dbdbdb",
                marginTop: 20,
                alignItems: "center",
              }}
              className={classes.card}
            >
              <Box>
                <img
                  src={`https://nitish.musafirbazar.com/static/media/${"SG"}.gif`}
                  width="50px"
                  height="50px"
                ></img>
                <span style={{ marginLeft: 10 }}>SpiceJet SG 328</span>
              </Box>
              <Box style={{ textAlign: "center" }}>
                <span style={{ fontSize: 18 }}>IXB</span>
                <p style={{ fontSize: 25 }}>15:55</p>
              </Box>
              <Box style={{ textAlign: "center" }}>
                <span style={{ color: "#ee8622" }}>2 hrs 50 mins</span>
                <p style={{ color: "#ee8622" }}>Direct</p>
              </Box>
              <Box style={{ textAlign: "center" }}>
                <span style={{ fontSize: 18 }}>BLR</span>
                <p style={{ fontSize: 25 }}>15:55</p>
              </Box>
              <Box style={{ textAlign: "center",cursor:'pointer' }} onClick={()=>history.push('/summaryflight')}>
                <span
                  style={{
                    background: "#ee8622",
                    color: "white",
                    fontWeight: "bold",
                    padding: "10px",
                  }}
                >
                  BOOK
                </span>
                <p style={{ marginTop: 10 }}>Seat Left: 8</p>
              </Box>
            </Box>
          );
        })}
      </Container>
      <SlideDownModal
        open={open}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
      />
      <Footer />
    </div>
  );
};

export default SearchResult;
